import { render, staticRenderFns } from "./SectionFastAnswers.vue?vue&type=template&id=349b7af6&scoped=true&"
import script from "./SectionFastAnswers.vue?vue&type=script&lang=js&"
export * from "./SectionFastAnswers.vue?vue&type=script&lang=js&"
import style0 from "./SectionFastAnswers.vue?vue&type=style&index=0&id=349b7af6&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349b7af6",
  null
  
)

export default component.exports